<template>
  <GlitchBackground />
  <div class="ssm-layout">
    <NavBar />
    <AlertMessage
      v-if="$route.query.error"
      :content="$route.query.error"
      type="error"
    />
    <div :class="{ourcontainer: $route.name !== 'scoreboard'}">
      <router-view />
    </div>
  </div>
  <ChallengeModal id="challengeModal">
    test contents
  </ChallengeModal>
  <ToastMessages />
</template>

<script>
import ChallengeModal from '@/components/ChallengeModal.vue'
import GlitchBackground from '@/components/GlitchBackground.vue'
import NavBar from '@/components/NavBar.vue'
import AlertMessage from '@/components/AlertMessage.vue'
import ToastMessages from '@/components/ToastMessages.vue'
export default {
    components: {
        ChallengeModal,
        GlitchBackground,
        NavBar,
        AlertMessage,
        ToastMessages,
    },
}
</script>

<style lang="scss" scoped>
.ssm-layout {
    min-height: 100vh;
    padding-bottom: 3rem;
}

.ourcontainer {
  margin: 1.5rem auto 0;
  max-width: 1110px;
  padding: 0 1rem;
}
</style>
